import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import './WishlistPage.css'
import Spinner from "../components/Spinner";

export default function WishlistPage() {
  const [wishlist, setWishlist] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const API_BASE = process.env.REACT_APP_API_URL || "https://api.goharesadaf.ir";

  const loadWishlist = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/wishlist`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      });
      const data = await res.json();
      setWishlist(data);
    } catch (err) {
      console.error("Failed to load wishlist", err);
    } finally {
      setLoading(false);
    }
  };

  const removeFromWishlist = async (productId) => {
    await fetch(`${API_BASE}/api/wishlist/${productId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
    setWishlist((prev) => prev.filter((p) => p.id !== productId));
  };

  useEffect(() => {
    loadWishlist();
  }, []);

  if (loading) {
    return <Spinner />;
  }

  return (
    <div className="wishlist-container">

      <button className="back-btn" onClick={() => navigate(-1)}>
       بازگشت ⬅
      </button>

      <h2>فهرست علاقه‌مندی‌ها</h2>
      {wishlist.length === 0 ? (
        <p>هیچ محصولی در فهرست علاقه‌مندی‌ها نیست!</p>
      ) : (
        <div className="wishlist-grid">
          {wishlist.map((product) => (
            <div key={product.id} className="wishlist-card">
              <img src={product.main_image} alt={product.title} />
              <h3>{product.title}</h3>
              <p>
                {product.price
                  ? `${parseFloat(product.price).toLocaleString("fa-IR")} تومان`
                  : "لطفاً برای قیمت تماس بگیرید"}
              </p>
              <button onClick={() => removeFromWishlist(product.id)}>
                حذف از لیست
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
